import React, { useEffect, useState } from "react";
import { Modal, Select, Form, Button, Input, Space, Typography } from "antd";
import { swalNotification } from "../../../../../components/alret/notificztion";
import { validationErrors } from "../../../../../utils/Helpers";
import { patchRiderZone } from "../../../../../services/riders.service";
import { getZoneList } from "../../../../../services/zone.service";
import altimg from "../../../../../assets/images/placeholder/placeimg50.png";
const { Title, Text } = Typography;
const { Option } = Select;
const ModalDetailAssignRiderZones = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);

  const handleOkOrder = async (values) => {
    try {
      setMBtnLoading(true);
      await patchRiderZone(values);
      swalNotification(
        "Rider Zone",
        "Rider Zone Assign successfully",
        "success"
      );
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };
  const handleCancel = () => {
    props.setvisible(false);
  };

  useEffect(() => {
    form.setFieldsValue(props.postDataRiderFilter);
  }, [props.postDataRiderFilter]);
  const [form] = Form.useForm();

  return (
    <Modal
      title="Zone visible"
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
        <Button form="modalForm" loading={MBtnLoading} htmlType="submit">
          Save
        </Button>,
      ]}
    >
      <Form
        form={form}
        id="modalForm"
        layout="vertical"
        onFinish={handleOkOrder}
      >
        <Form.Item hidden name={"riderId"}></Form.Item>
        <Form.Item
          name={["zoneIds"]}
          label="Select Zone"
          rules={[{ required: true, message: "Zone is Required" }]}
        >
          <Select
            disabled={MBtnLoading}
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            placeholder="Please select Zone"
            style={{
              minWidth: "100%",
            }}
          >
            {props.postDataZoneOption}
          </Select>
        </Form.Item>
        <Form.Item
          disabled
          name={"riderfullName"}
          label="Rider Name"
          rules={[{ required: true, message: "Rider is Required" }]}
        >
          <Input disabled />
        </Form.Item>
      </Form>
      <div className="krflex krbadge">{props.VisibleZoneData}</div>
      <Space direction="horizontal">
        <Space>
          {props.riderData.profileImage ? (
            <img
              style={{ width: " 55px", height: "65px", objectFit: "cover" }}
              alt="Profile Image"
              src={props.riderData.profileImage}
            />
          ) : (
            <img alt="Profile Image" src={altimg} />
          )}
        </Space>
        <Space direction="vertical">
          {props.riderData[0].fullName ? (
            <Title level={5} style={{ margin: "0" }}>
              {props.riderData[0].fullName}
            </Title>
          ) : (
            "-"
          )}
          {props.riderData[0].display_id ? (
            <Text>{props.riderData[0].display_id}</Text>
          ) : (
            "-"
          )}
        </Space>
      </Space>
    </Modal>
  );
};

export default ModalDetailAssignRiderZones;
